module.exports = __webpack_public_path__ + "static/media/logo-cmtech-small-2.f62ba6f7.png";